import { render, staticRenderFns } from "./AnualReport.vue?vue&type=template&id=0827e0a8&"
import script from "./AnualReport.vue?vue&type=script&lang=js&"
export * from "./AnualReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports